import React from "react";
import AnalyticalReportingIcon from "../../assets/icons/reporting_analytical.svg2";
import RealtimeReportingIcon from "../../assets/icons/realtime_reporting.svg2";
import SystemReportingIcon from "../../assets/icons/reporting_system.svg2";
import PageNavLinks from "../Common/PageNavLinks";
import TicketingIcon from "../../assets/icons/tiket_reporting.svg2";
import ProcessesIcon from "../../assets/icons/process_reports.svg2";
import AssetsIcon from "../../assets/icons/asset-01.svg2";
import EventsIcon from "../../assets/icons/Icon_Library/application icons/assets/events.svg2";

export const reportingLinks = [
  {
    label: "Real-time Report",
    Icon: RealtimeReportingIcon,
    href: "/reporting/realtime",
  },
  {
    label: "Ticket",
    Icon: TicketingIcon,
    href: "/reporting/ticketing",
  },
  {
    label: "Processes",
    Icon: ProcessesIcon,
    href: "/reporting/processes",
  },
  {
    label: "System Report",
    Icon: SystemReportingIcon,
    href: "/reporting/system",
    newFeature: true,
  },

  {
    label: "Assets",
    Icon: AssetsIcon,
    href: "/reporting/assets",
    newFeature: true,
  },
  {
    label: "Events",
    Icon: EventsIcon,
    href: "/reporting/events",
    newFeature: true,
  },
  {
    label: "Analytical Report",
    Icon: AnalyticalReportingIcon,
    href: "/reporting/analytical",
    newFeature: true,
  },
];

export default function ReportingLinks() {
  return <PageNavLinks pageName="reporting" links={reportingLinks} />;
}
